// src/pages/Templates.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Spinner, Badge } from 'react-bootstrap';
import { industrySections } from '../data/industrySections';
import { ArrowRight } from 'lucide-react';

const Templates = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [industries, setIndustries] = useState([]);

  useEffect(() => {
    try {
      const industryList = Object.keys(industrySections).map((key) => ({
        id: key,
        name: industrySections[key]?.name || key,
        icon: industrySections[key]?.icon || '📄',
        sectionCount: industrySections[key]?.sections?.length || 0,
      }));

      setIndustries(industryList);
      setLoading(false);
    } catch (error) {
      console.error('❌ Error loading industries:', error);
      setLoading(false);
    }
  }, []);

  const handleCardClick = (industryId) => {
    navigate(`/builder?industry=${industryId}`);
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '60vh', paddingTop: '80px' }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3 text-muted">Loading industries...</p>
        </div>
      </div>
    );
  }

  const totalSections = industries.reduce((acc, ind) => acc + ind.sectionCount, 0);

  return (
    <div style={{ paddingTop: '80px', paddingBottom: '40px', minHeight: '100vh' }}>
      <Container>
        {/* Header */}
        <div className="text-center mb-5">
          <h1 className="display-4 fw-bold mb-3">Choose Your Industry</h1>
          <p className="text-muted lead">
            Click on your profession to start building your resume
          </p>
        </div>

        {/* Industry Grid */}
        <Row className="g-4">
          {industries.map((industry) => (
            <Col key={industry.id} md={4} sm={6} xs={12}>
              <Card
                className="h-100 text-center p-3 shadow-sm industry-card"
                style={{ cursor: 'pointer', border: 'none' }}
                onClick={() => handleCardClick(industry.id)}
              >
                <Card.Body className="d-flex flex-column align-items-center">
                  <div
                    className="industry-icon"
                    style={{ fontSize: '56px', lineHeight: 1 }}
                  >
                    {industry.icon}
                  </div>
                  <h5 className="mt-3 mb-1 industry-name">{industry.name}</h5>
                  <Badge bg="secondary" className="mb-2 industry-badge">
                    {industry.sectionCount} sections
                  </Badge>
                  <small className="text-primary industry-cta">
                    <ArrowRight size={14} className="me-1" />
                    Click to build
                  </small>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Quick Stats */}
        <div className="mt-5 pt-4 border-top">
          <Row className="g-4 justify-content-center text-center">
            <Col xs={6} md={3}>
              <div className="stat-card">
                <div className="stat-number">{industries.length}</div>
                <div className="stat-label">Industries Available</div>
              </div>
            </Col>

            <Col xs={6} md={3}>
              <div className="stat-card">
                <div className="stat-number">{totalSections}</div>
                <div className="stat-label">Total Sections</div>
              </div>
            </Col>

            <Col xs={6} md={3}>
              <div className="stat-card">
                <div className="stat-number">100%</div>
                <div className="stat-label">Free to Use</div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default Templates;